/** @import { MapLayerDockStore } from './map-layer-dock-state.js' */
/** @import { MapLayerDockService } from './map-layer-dock-service.js' */

export class MapLayerDockController {
  /** @type {MapLayerDockStore} */
  #store;

  /** @type {MapLayerDockService} */
  #service;

  /**
   * @param {MapLayerDockStore} store
   * @param {MapLayerDockService} service
   */
  constructor(store, service) {
    this.#store = store;
    this.#service = service;
  }

  /**
   * Toggles or switches the active content tab.
   * Selecting the same key closes the content panel. A different key switches to that tab.
   * @param {string} tabKey
   */
  selectTab(tabKey) {
    const state = this.#store.getState();

    // If the tab is already active, deselect it, otherwise select the new tab
    const isAlreadyActive = state.activeTabKey === tabKey;
    state.setActiveTabKey(isAlreadyActive ? null : tabKey);
  }

  /**
   * Changes the active map base by delegating to the service and handling any errors.
   * @param {string} mapBaseKey
   */
  selectMapBase(mapBaseKey) {
    try {
      this.#store.getState().setError(null);
      this.#service.selectMapBase(mapBaseKey);
    } catch (error) {
      this.#store.getState().setError(error.message);
    }
  }

  /**
   * Sets up a listener for map bases for the given user group
   * @param {string} userGroup
   */
  setUpMapBasesListener(userGroup) {
    if (!userGroup) return;
    this.#service.setUpMapBasesListener(userGroup);
  }

  /** Detaches all active listeners. */
  disconnectMapLayerDock() {
    this.#service.disconnectMapLayerDock();
  }
}
